module.exports = __webpack_public_path__ + "static/media/ig1.b1c33b7b.jpg";